import React, { createContext, useContext, useMemo, useState } from "react";

const ContactContext = createContext({
  contact: null,
  setContact: (_) => {},
});

export const ContactProvider = ({ children }) => {
  const [contact, setContact] = useState(null);
  const value = useMemo(() => ({ contact, setContact }), [contact]);

  return (
    <ContactContext.Provider value={value}>{children}</ContactContext.Provider>
  );
};
export const useContact = () => useContext(ContactContext);
export default ContactContext;
